import { Deserializable } from '../protocols/deserializable';
import { BaseType } from '../base/base-type';
import { BankAccount } from '../../views/banking/models/bank-account';
import { PaylineAccount } from '../../views/banking/models/payline-account';
import { PaymentMethodType } from '../shared/payment-method-type';
import { PaymentMethodTypeIdEnum } from '../enum/shared/payment-method-type-id.enum';
import { WithdrawalInstruction } from './withdrawal-instruction';
import { VariableBenefitGoverningJurisdictionDetail } from './variable-benefit-governing-jurisdiction-detail';
import { VariableBenefitSourceJurisdiction } from './variable-benefit-source-jurisdiction';
import { GoverningJurisdictionType } from '../employers/employer-history/types/governing-jurisdiction-type';
import { GoverningJurisdictionTypeId } from '../enum/shared/governing-jurisdiction-type-id';

export class VariableBenefitConfigurationSubmissionData implements Deserializable {
  public boardDirectedAccount!: boolean;
  public phasedRetirement!: boolean;
  public effectiveDate!: string;
  public paymentMethodId!: PaymentMethodTypeIdEnum | null;
  public paymentMethod!: PaymentMethodType | null;
  public bankAccountId!: number | null;
  public bankAccount!: BankAccount | null;
  public paylineAccountId!: number | null;
  public paylineAccount!: PaylineAccount | null;
  public targetRecurringPaymentAmount!: number | null;
  public recurringPaymentFrequencyId!: number;
  public recurringPaymentFrequency!: BaseType;
  public recurringPaymentStartDate!: string;
  public lumpSumPaymentDesiredPaymentDate!: string;
  public governingJurisdictionOverrideId!: GoverningJurisdictionTypeId | null;
  public governingJurisdictionOverride!: GoverningJurisdictionType | null;
  public sourceJurisdictions!: VariableBenefitSourceJurisdiction[];
  public destinationJurisdictions!: VariableBenefitGoverningJurisdictionDetail[];
  public withdrawalInstructions!: WithdrawalInstruction[];

  public onDeserialize() {
    const Deserialize = window.injector.Deserialize;

    if (this.paymentMethod) {
      this.paymentMethod = Deserialize.instanceOf(PaymentMethodType, this.paymentMethod);
    }

    if (this.bankAccount) {
      this.bankAccount = Deserialize.instanceOf(BankAccount, this.bankAccount);
    }

    if (this.paylineAccount) {
      this.paylineAccount = Deserialize.instanceOf(PaylineAccount, this.paylineAccount);
    }

    if (this.withdrawalInstructions) {
      this.withdrawalInstructions = Deserialize.arrayOf(WithdrawalInstruction, this.withdrawalInstructions);
    }

    if (this.governingJurisdictionOverride) {
      this.governingJurisdictionOverride = Deserialize.instanceOf(
        GoverningJurisdictionType,
        this.governingJurisdictionOverride
      );
    }

    if (this.sourceJurisdictions) {
      this.sourceJurisdictions = Deserialize.arrayOf(VariableBenefitSourceJurisdiction, this.sourceJurisdictions);
    }

    if (this.destinationJurisdictions) {
      this.destinationJurisdictions = Deserialize.arrayOf(
        VariableBenefitGoverningJurisdictionDetail,
        this.destinationJurisdictions
      );
    }
  }
}
